// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { LiftType } from "./lift-type";
import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * A command template in the action catalog.
 */
export class ActionCatalog implements flatbuffers.IUnpackableObject<ActionCatalogT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ActionCatalog {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsActionCatalog(bb: flatbuffers.ByteBuffer, obj?: ActionCatalog): ActionCatalog {
    return (obj || new ActionCatalog()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsActionCatalog(
    bb: flatbuffers.ByteBuffer,
    obj?: ActionCatalog,
  ): ActionCatalog {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new ActionCatalog()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  id(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  messageId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  liftType(): LiftType {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : LiftType.ELEVATOR;
  }

  cmd(): string;
  cmd(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  cmd(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  label(): string;
  label(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  label(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  tooltip(): string;
  tooltip(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  tooltip(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  type(): string | null;
  type(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  type(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  encodedType(): number {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
  }

  messageContent(): number {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
  }

  messageValue(): number {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  targetPosition(): number {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  /**
   * `PostgreSQL` text[] — stored as a `FlatBuffer` string vector.
   */
  validStates(index: number): string;
  validStates(index: number, optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  validStates(index: number, optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset
      ? this.bb!.__string(this.bb!.__vector(this.bb_pos + offset) + index * 4, optionalEncoding)
      : null;
  }

  validStatesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  createdAt(): string | null;
  createdAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  createdAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 28);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  updatedAt(): string | null;
  updatedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  updatedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 30);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  deletedAt(): string | null;
  deletedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  deletedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 32);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * Wizard-mode scoping: the bank this catalog row belongs to.
   * NULL for legacy/template rows shared across banks.
   */
  bankId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 34);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  organizationId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 36);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  /**
   * Wizard metadata: the lift this action targets. NULL = bank-wide.
   * Runtime buttons stay bank-scoped; UiCmd.lift_id targets the car.
   */
  liftId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 38);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  /**
   * Wizard-set button behaviour — catalog-level defaults. The bank's
   * `action_banks` row (materialized at create time) wins at monitor
   * time when present. button_type holds the ActionButtonType enum
   * NAME ("TOGGLE", "TURNBACK", ...) mirroring the Go model's
   * nullable *string column.
   */
  buttonType(): string | null;
  buttonType(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  buttonType(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 40);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  timer(): number {
    const offset = this.bb!.__offset(this.bb_pos, 42);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  toggleTimer(): number {
    const offset = this.bb!.__offset(this.bb_pos, 44);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  toggleCmd(): string | null;
  toggleCmd(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  toggleCmd(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 46);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  toggleLabel(): string | null;
  toggleLabel(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  toggleLabel(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 48);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * Control-enum value backing toggle_cmd so the backend can resolve
   * the toggle Message row without adapter-key archaeology. 0 = unset
   * (sentinel, matching the in-schema timer convention).
   */
  toggleMessageValue(): number {
    const offset = this.bb!.__offset(this.bb_pos, 50);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  /**
   * Expected-response verification: the ids of the `messages` rows whose
   * arrival confirms an action built from this catalog row succeeded.
   *
   * Same storage convention as `valid_states` — a `PostgreSQL` text[] of
   * message UUIDs, carried as a `FlatBuffer` string vector. Every listed
   * message must be observed (active) at least once within
   * `expected_response_timeout` for the action to count as verified.
   *
   * INVARIANT: absent/empty means the action has NO expected response. A
   * consumer must report such an action as "sent, unverifiable" — never as
   * verified and never as failed. Nothing on the wire acknowledges a
   * command; verification is the monitoring client correlating the
   * broadcast it already receives.
   *
   * This is the wizard-level DEFAULT; `ActionBank.expected_response` is the
   * runtime copy the control panel reads.
   *
   * Appended last, so buffers written before it stay readable.
   */
  expectedResponse(index: number): string;
  expectedResponse(index: number, optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  expectedResponse(index: number, optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 52);
    return offset
      ? this.bb!.__string(this.bb!.__vector(this.bb_pos + offset) + index * 4, optionalEncoding)
      : null;
  }

  expectedResponseLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 52);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Verification window in seconds for `expected_response`.
   *
   * INVARIANT: 0 is indistinguishable from absent and means UNSET — the
   * consumer applies its own default window. It is NOT "no timeout" and NOT
   * "verify immediately". Only meaningful when `expected_response` is
   * non-empty. Appended last, so buffers written before it stay readable.
   */
  expectedResponseTimeout(): number {
    const offset = this.bb!.__offset(this.bb_pos, 54);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  static startActionCatalog(builder: flatbuffers.Builder) {
    builder.startObject(26);
  }

  static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, idOffset, 0);
  }

  static addMessageId(builder: flatbuffers.Builder, messageIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, messageIdOffset, 0);
  }

  static addLiftType(builder: flatbuffers.Builder, liftType: LiftType) {
    builder.addFieldInt8(2, liftType, LiftType.ELEVATOR);
  }

  static addCmd(builder: flatbuffers.Builder, cmdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, cmdOffset, 0);
  }

  static addLabel(builder: flatbuffers.Builder, labelOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, labelOffset, 0);
  }

  static addTooltip(builder: flatbuffers.Builder, tooltipOffset: flatbuffers.Offset) {
    builder.addFieldOffset(5, tooltipOffset, 0);
  }

  static addType(builder: flatbuffers.Builder, typeOffset: flatbuffers.Offset) {
    builder.addFieldOffset(6, typeOffset, 0);
  }

  static addEncodedType(builder: flatbuffers.Builder, encodedType: number) {
    builder.addFieldInt16(7, encodedType, 0);
  }

  static addMessageContent(builder: flatbuffers.Builder, messageContent: number) {
    builder.addFieldInt16(8, messageContent, 0);
  }

  static addMessageValue(builder: flatbuffers.Builder, messageValue: number) {
    builder.addFieldInt32(9, messageValue, 0);
  }

  static addTargetPosition(builder: flatbuffers.Builder, targetPosition: number) {
    builder.addFieldInt32(10, targetPosition, 0);
  }

  static addValidStates(builder: flatbuffers.Builder, validStatesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(11, validStatesOffset, 0);
  }

  static createValidStatesVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startValidStatesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addCreatedAt(builder: flatbuffers.Builder, createdAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(12, createdAtOffset, 0);
  }

  static addUpdatedAt(builder: flatbuffers.Builder, updatedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(13, updatedAtOffset, 0);
  }

  static addDeletedAt(builder: flatbuffers.Builder, deletedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(14, deletedAtOffset, 0);
  }

  static addBankId(builder: flatbuffers.Builder, bankIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(15, bankIdOffset, 0);
  }

  static addOrganizationId(builder: flatbuffers.Builder, organizationIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(16, organizationIdOffset, 0);
  }

  static addLiftId(builder: flatbuffers.Builder, liftIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(17, liftIdOffset, 0);
  }

  static addButtonType(builder: flatbuffers.Builder, buttonTypeOffset: flatbuffers.Offset) {
    builder.addFieldOffset(18, buttonTypeOffset, 0);
  }

  static addTimer(builder: flatbuffers.Builder, timer: number) {
    builder.addFieldInt32(19, timer, 0);
  }

  static addToggleTimer(builder: flatbuffers.Builder, toggleTimer: number) {
    builder.addFieldInt32(20, toggleTimer, 0);
  }

  static addToggleCmd(builder: flatbuffers.Builder, toggleCmdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(21, toggleCmdOffset, 0);
  }

  static addToggleLabel(builder: flatbuffers.Builder, toggleLabelOffset: flatbuffers.Offset) {
    builder.addFieldOffset(22, toggleLabelOffset, 0);
  }

  static addToggleMessageValue(builder: flatbuffers.Builder, toggleMessageValue: number) {
    builder.addFieldInt32(23, toggleMessageValue, 0);
  }

  static addExpectedResponse(
    builder: flatbuffers.Builder,
    expectedResponseOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(24, expectedResponseOffset, 0);
  }

  static createExpectedResponseVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startExpectedResponseVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addExpectedResponseTimeout(builder: flatbuffers.Builder, expectedResponseTimeout: number) {
    builder.addFieldInt32(25, expectedResponseTimeout, 0);
  }

  static endActionCatalog(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // id
    builder.requiredField(offset, 10); // cmd
    builder.requiredField(offset, 12); // label
    builder.requiredField(offset, 14); // tooltip
    return offset;
  }

  unpack(): ActionCatalogT {
    return new ActionCatalogT(
      this.id() !== null ? this.id()!.unpack() : null,
      this.messageId() !== null ? this.messageId()!.unpack() : null,
      this.liftType(),
      this.cmd(),
      this.label(),
      this.tooltip(),
      this.type(),
      this.encodedType(),
      this.messageContent(),
      this.messageValue(),
      this.targetPosition(),
      this.bb!.createScalarList<string>(this.validStates.bind(this), this.validStatesLength()),
      this.createdAt(),
      this.updatedAt(),
      this.deletedAt(),
      this.bankId() !== null ? this.bankId()!.unpack() : null,
      this.organizationId() !== null ? this.organizationId()!.unpack() : null,
      this.liftId() !== null ? this.liftId()!.unpack() : null,
      this.buttonType(),
      this.timer(),
      this.toggleTimer(),
      this.toggleCmd(),
      this.toggleLabel(),
      this.toggleMessageValue(),
      this.bb!.createScalarList<string>(
        this.expectedResponse.bind(this),
        this.expectedResponseLength(),
      ),
      this.expectedResponseTimeout(),
    );
  }

  unpackTo(_o: ActionCatalogT): void {
    _o.id = this.id() !== null ? this.id()!.unpack() : null;
    _o.messageId = this.messageId() !== null ? this.messageId()!.unpack() : null;
    _o.liftType = this.liftType();
    _o.cmd = this.cmd();
    _o.label = this.label();
    _o.tooltip = this.tooltip();
    _o.type = this.type();
    _o.encodedType = this.encodedType();
    _o.messageContent = this.messageContent();
    _o.messageValue = this.messageValue();
    _o.targetPosition = this.targetPosition();
    _o.validStates = this.bb!.createScalarList<string>(
      this.validStates.bind(this),
      this.validStatesLength(),
    );
    _o.createdAt = this.createdAt();
    _o.updatedAt = this.updatedAt();
    _o.deletedAt = this.deletedAt();
    _o.bankId = this.bankId() !== null ? this.bankId()!.unpack() : null;
    _o.organizationId = this.organizationId() !== null ? this.organizationId()!.unpack() : null;
    _o.liftId = this.liftId() !== null ? this.liftId()!.unpack() : null;
    _o.buttonType = this.buttonType();
    _o.timer = this.timer();
    _o.toggleTimer = this.toggleTimer();
    _o.toggleCmd = this.toggleCmd();
    _o.toggleLabel = this.toggleLabel();
    _o.toggleMessageValue = this.toggleMessageValue();
    _o.expectedResponse = this.bb!.createScalarList<string>(
      this.expectedResponse.bind(this),
      this.expectedResponseLength(),
    );
    _o.expectedResponseTimeout = this.expectedResponseTimeout();
  }

  unpackFields(...fields: string[]): ActionCatalogT {
    const t = new ActionCatalogT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("id")) {
      t.id = this.id() !== null ? this.id()!.unpack() : null;
    }
    if (fieldSet.has("message_id")) {
      t.messageId = this.messageId() !== null ? this.messageId()!.unpack() : null;
    }
    if (fieldSet.has("lift_type")) {
      t.liftType = this.liftType();
    }
    if (fieldSet.has("cmd")) {
      t.cmd = this.cmd();
    }
    if (fieldSet.has("label")) {
      t.label = this.label();
    }
    if (fieldSet.has("tooltip")) {
      t.tooltip = this.tooltip();
    }
    if (fieldSet.has("type")) {
      t.type = this.type();
    }
    if (fieldSet.has("encoded_type")) {
      t.encodedType = this.encodedType();
    }
    if (fieldSet.has("message_content")) {
      t.messageContent = this.messageContent();
    }
    if (fieldSet.has("message_value")) {
      t.messageValue = this.messageValue();
    }
    if (fieldSet.has("target_position")) {
      t.targetPosition = this.targetPosition();
    }
    if (fieldSet.has("valid_states")) {
      t.validStates = this.bb!.createScalarList<string>(
        this.validStates.bind(this),
        this.validStatesLength(),
      );
    }
    if (fieldSet.has("created_at")) {
      t.createdAt = this.createdAt();
    }
    if (fieldSet.has("updated_at")) {
      t.updatedAt = this.updatedAt();
    }
    if (fieldSet.has("deleted_at")) {
      t.deletedAt = this.deletedAt();
    }
    if (fieldSet.has("bank_id")) {
      t.bankId = this.bankId() !== null ? this.bankId()!.unpack() : null;
    }
    if (fieldSet.has("organization_id")) {
      t.organizationId = this.organizationId() !== null ? this.organizationId()!.unpack() : null;
    }
    if (fieldSet.has("lift_id")) {
      t.liftId = this.liftId() !== null ? this.liftId()!.unpack() : null;
    }
    if (fieldSet.has("button_type")) {
      t.buttonType = this.buttonType();
    }
    if (fieldSet.has("timer")) {
      t.timer = this.timer();
    }
    if (fieldSet.has("toggle_timer")) {
      t.toggleTimer = this.toggleTimer();
    }
    if (fieldSet.has("toggle_cmd")) {
      t.toggleCmd = this.toggleCmd();
    }
    if (fieldSet.has("toggle_label")) {
      t.toggleLabel = this.toggleLabel();
    }
    if (fieldSet.has("toggle_message_value")) {
      t.toggleMessageValue = this.toggleMessageValue();
    }
    if (fieldSet.has("expected_response")) {
      t.expectedResponse = this.bb!.createScalarList<string>(
        this.expectedResponse.bind(this),
        this.expectedResponseLength(),
      );
    }
    if (fieldSet.has("expected_response_timeout")) {
      t.expectedResponseTimeout = this.expectedResponseTimeout();
    }
    return t;
  }
}

export class ActionCatalogT implements flatbuffers.IGeneratedObject {
  constructor(
    public id: UuidT | null = null,
    public messageId: UuidT | null = null,
    public liftType: LiftType = LiftType.ELEVATOR,
    public cmd: string | Uint8Array | null = null,
    public label: string | Uint8Array | null = null,
    public tooltip: string | Uint8Array | null = null,
    public type: string | Uint8Array | null = null,
    public encodedType: number = 0,
    public messageContent: number = 0,
    public messageValue: number = 0,
    public targetPosition: number = 0,
    public validStates: string[] = [],
    public createdAt: string | Uint8Array | null = null,
    public updatedAt: string | Uint8Array | null = null,
    public deletedAt: string | Uint8Array | null = null,
    public bankId: UuidT | null = null,
    public organizationId: UuidT | null = null,
    public liftId: UuidT | null = null,
    public buttonType: string | Uint8Array | null = null,
    public timer: number = 0,
    public toggleTimer: number = 0,
    public toggleCmd: string | Uint8Array | null = null,
    public toggleLabel: string | Uint8Array | null = null,
    public toggleMessageValue: number = 0,
    public expectedResponse: string[] = [],
    public expectedResponseTimeout: number = 0,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.id === null || this.id === undefined) {
      throw new Error('Required field "id" is not set');
    }
    if (this.cmd === null || this.cmd === undefined) {
      throw new Error('Required field "cmd" is not set');
    }
    if (this.label === null || this.label === undefined) {
      throw new Error('Required field "label" is not set');
    }
    if (this.tooltip === null || this.tooltip === undefined) {
      throw new Error('Required field "tooltip" is not set');
    }
    const id = this.id !== null ? this.id!.pack(builder) : 0;
    const messageId = this.messageId !== null ? this.messageId!.pack(builder) : 0;
    const cmd = this.cmd !== null ? builder.createString(this.cmd!) : 0;
    const label = this.label !== null ? builder.createString(this.label!) : 0;
    const tooltip = this.tooltip !== null ? builder.createString(this.tooltip!) : 0;
    const type = this.type !== null ? builder.createString(this.type!) : 0;
    const validStates = ActionCatalog.createValidStatesVector(
      builder,
      builder.createObjectOffsetList(this.validStates),
    );
    const createdAt = this.createdAt !== null ? builder.createString(this.createdAt!) : 0;
    const updatedAt = this.updatedAt !== null ? builder.createString(this.updatedAt!) : 0;
    const deletedAt = this.deletedAt !== null ? builder.createString(this.deletedAt!) : 0;
    const bankId = this.bankId !== null ? this.bankId!.pack(builder) : 0;
    const organizationId = this.organizationId !== null ? this.organizationId!.pack(builder) : 0;
    const liftId = this.liftId !== null ? this.liftId!.pack(builder) : 0;
    const buttonType = this.buttonType !== null ? builder.createString(this.buttonType!) : 0;
    const toggleCmd = this.toggleCmd !== null ? builder.createString(this.toggleCmd!) : 0;
    const toggleLabel = this.toggleLabel !== null ? builder.createString(this.toggleLabel!) : 0;
    const expectedResponse = ActionCatalog.createExpectedResponseVector(
      builder,
      builder.createObjectOffsetList(this.expectedResponse),
    );

    ActionCatalog.startActionCatalog(builder);
    ActionCatalog.addId(builder, id);
    ActionCatalog.addMessageId(builder, messageId);
    ActionCatalog.addLiftType(builder, this.liftType);
    ActionCatalog.addCmd(builder, cmd);
    ActionCatalog.addLabel(builder, label);
    ActionCatalog.addTooltip(builder, tooltip);
    ActionCatalog.addType(builder, type);
    ActionCatalog.addEncodedType(builder, this.encodedType);
    ActionCatalog.addMessageContent(builder, this.messageContent);
    ActionCatalog.addMessageValue(builder, this.messageValue);
    ActionCatalog.addTargetPosition(builder, this.targetPosition);
    ActionCatalog.addValidStates(builder, validStates);
    ActionCatalog.addCreatedAt(builder, createdAt);
    ActionCatalog.addUpdatedAt(builder, updatedAt);
    ActionCatalog.addDeletedAt(builder, deletedAt);
    ActionCatalog.addBankId(builder, bankId);
    ActionCatalog.addOrganizationId(builder, organizationId);
    ActionCatalog.addLiftId(builder, liftId);
    ActionCatalog.addButtonType(builder, buttonType);
    ActionCatalog.addTimer(builder, this.timer);
    ActionCatalog.addToggleTimer(builder, this.toggleTimer);
    ActionCatalog.addToggleCmd(builder, toggleCmd);
    ActionCatalog.addToggleLabel(builder, toggleLabel);
    ActionCatalog.addToggleMessageValue(builder, this.toggleMessageValue);
    ActionCatalog.addExpectedResponse(builder, expectedResponse);
    ActionCatalog.addExpectedResponseTimeout(builder, this.expectedResponseTimeout);

    return ActionCatalog.endActionCatalog(builder);
  }

  clone(): ActionCatalogT {
    const obj = new ActionCatalogT();
    obj.id = this.id !== null ? this.id!.clone() : null;
    obj.messageId = this.messageId !== null ? this.messageId!.clone() : null;
    obj.liftType = this.liftType;
    obj.cmd = this.cmd;
    obj.label = this.label;
    obj.tooltip = this.tooltip;
    obj.type = this.type;
    obj.encodedType = this.encodedType;
    obj.messageContent = this.messageContent;
    obj.messageValue = this.messageValue;
    obj.targetPosition = this.targetPosition;
    obj.validStates = [...this.validStates];
    obj.createdAt = this.createdAt;
    obj.updatedAt = this.updatedAt;
    obj.deletedAt = this.deletedAt;
    obj.bankId = this.bankId !== null ? this.bankId!.clone() : null;
    obj.organizationId = this.organizationId !== null ? this.organizationId!.clone() : null;
    obj.liftId = this.liftId !== null ? this.liftId!.clone() : null;
    obj.buttonType = this.buttonType;
    obj.timer = this.timer;
    obj.toggleTimer = this.toggleTimer;
    obj.toggleCmd = this.toggleCmd;
    obj.toggleLabel = this.toggleLabel;
    obj.toggleMessageValue = this.toggleMessageValue;
    obj.expectedResponse = [...this.expectedResponse];
    obj.expectedResponseTimeout = this.expectedResponseTimeout;
    return obj;
  }

  equals(other: ActionCatalogT): boolean {
    if (this.id !== null && other.id !== null) {
      if (!this.id!.equals(other.id!)) return false;
    } else if (this.id !== other.id) return false;
    if (this.messageId !== null && other.messageId !== null) {
      if (!this.messageId!.equals(other.messageId!)) return false;
    } else if (this.messageId !== other.messageId) return false;
    if (this.liftType !== other.liftType) return false;
    if (this.cmd !== other.cmd) return false;
    if (this.label !== other.label) return false;
    if (this.tooltip !== other.tooltip) return false;
    if (this.type !== other.type) return false;
    if (this.encodedType !== other.encodedType) return false;
    if (this.messageContent !== other.messageContent) return false;
    if (this.messageValue !== other.messageValue) return false;
    if (this.targetPosition !== other.targetPosition) return false;
    if (this.validStates.length !== other.validStates.length) return false;
    for (let i = 0; i < this.validStates.length; i++) {
      if (this.validStates[i] !== other.validStates[i]) return false;
    }
    if (this.createdAt !== other.createdAt) return false;
    if (this.updatedAt !== other.updatedAt) return false;
    if (this.deletedAt !== other.deletedAt) return false;
    if (this.bankId !== null && other.bankId !== null) {
      if (!this.bankId!.equals(other.bankId!)) return false;
    } else if (this.bankId !== other.bankId) return false;
    if (this.organizationId !== null && other.organizationId !== null) {
      if (!this.organizationId!.equals(other.organizationId!)) return false;
    } else if (this.organizationId !== other.organizationId) return false;
    if (this.liftId !== null && other.liftId !== null) {
      if (!this.liftId!.equals(other.liftId!)) return false;
    } else if (this.liftId !== other.liftId) return false;
    if (this.buttonType !== other.buttonType) return false;
    if (this.timer !== other.timer) return false;
    if (this.toggleTimer !== other.toggleTimer) return false;
    if (this.toggleCmd !== other.toggleCmd) return false;
    if (this.toggleLabel !== other.toggleLabel) return false;
    if (this.toggleMessageValue !== other.toggleMessageValue) return false;
    if (this.expectedResponse.length !== other.expectedResponse.length) return false;
    for (let i = 0; i < this.expectedResponse.length; i++) {
      if (this.expectedResponse[i] !== other.expectedResponse[i]) return false;
    }
    if (this.expectedResponseTimeout !== other.expectedResponseTimeout) return false;
    return true;
  }
}

export function verifyActionCatalog(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "id");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkScalarField(tablePos, 8, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 10, "cmd");
    {
      const pos = verifier.checkOffsetField(tablePos, 12);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 12, "label");
    {
      const pos = verifier.checkOffsetField(tablePos, 14);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 14, "tooltip");
    {
      const pos = verifier.checkOffsetField(tablePos, 16);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 18, 2);
    verifier.checkScalarField(tablePos, 20, 2);
    verifier.checkScalarField(tablePos, 22, 4);
    verifier.checkScalarField(tablePos, 24, 4);
    {
      const pos = verifier.checkOffsetField(tablePos, 26);
      if (pos !== 0) {
        const len = verifier.checkVector(pos, 4);
        if (len > 0) {
          const vecStart = pos + verifier.readInt32(pos);
          const dataStart = vecStart + 4;
          for (let i = 0; i < len; i++) {
            const strPos = dataStart + i * 4;
            verifier.checkString(strPos);
          }
        }
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 28);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 30);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 32);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 34);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 36);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 38);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 40);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 42, 4);
    verifier.checkScalarField(tablePos, 44, 4);
    {
      const pos = verifier.checkOffsetField(tablePos, 46);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 48);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 50, 4);
    {
      const pos = verifier.checkOffsetField(tablePos, 52);
      if (pos !== 0) {
        const len = verifier.checkVector(pos, 4);
        if (len > 0) {
          const vecStart = pos + verifier.readInt32(pos);
          const dataStart = vecStart + 4;
          for (let i = 0; i < len; i++) {
            const strPos = dataStart + i * 4;
            verifier.checkString(strPos);
          }
        }
      }
    }
    verifier.checkScalarField(tablePos, 54, 4);
  } finally {
    verifier.popDepth();
  }
}
